<template>
  <div class="contact-us-info">
    <div class="space-y-4">
      <p class="contact-us-info__text">
        <span>{{ $t('common.labels.address') }}:</span>
        <span class="font-bold text-body-1">{{ $config.contact_us.address }}</span>
      </p>
      <div class="lg:flex lg:space-x-8">
        <p class="contact-us-info__text mb-4 lg:mb-0">
          <span>{{ $t('common.labels.phone') }}:</span>
          <span class="font-bold text-body-1">{{ $config.contact_us.phone }}</span>
        </p>
        <p class="contact-us-info__text">
          <span>{{ $t('common.labels.email') }}:</span>
          <span class="font-bold text-body-1">{{ $config.contact_us.email }}</span>
        </p>
      </div>
      <p class="contact-us-info__text">
        <span>{{ $t('common.labels.kvk_number') }}:</span>
        <span class="font-bold text-body-1">{{ $config.contact_us.kvk_number }}</span>
      </p>
      <p class="contact-us-info__text">
        <span>{{ $t('common.labels.trade_name') }}:</span>
        <span class="font-bold text-body-1">{{ $config.contact_us.trade_name }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUsInfo',
  data () {
    return {
      socialMedias: [
        {
          icon: 'linkedin',
          link: null
        },
        {
          icon: 'twitter',
          link: null
        },
        {
          icon: 'instagram',
          link: null
        },
        {
          icon: 'facebook',
          link: null
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.contact-us-info {
  @apply bg-primary-200 shadow-banner rounded-2xl px-4 py-6 lg:px-8 lg:py-6 flex
  lg:flex-row flex-col text-center lg:text-left;
  &__title {
    @apply text__headline-2-xs--bold lg:text__headline-4-md--bold text-primary-700;
  }
  &__text {
    @apply  text__body-2-xs--semibold lg:text__body-1-md--semibold text-body-2 flex lg:flex-row flex-col
    lg:space-x-4 space-y-2 lg:space-y-0;
  }
}
</style>
